import React, { Fragment, useContext } from "react";
import { observer } from "mobx-react-lite";
import { StoreContext, storeInterface, store } from "../store";
import { useQuery } from "react-apollo-hooks";
import { Link as RouterLink } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { withStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Typography, Paper, Button, CircularProgress } from "@material-ui/core";
import { isEmpty } from "underscore";
import {
  getAllActivities,
  ActivityInterface,
  lessonInterface,
  getAllACtivitiesInterface,
  quizInterface,
  GET_GRADES,
} from "../queriesAndMutations";
import axios from "axios";
import CheckRecovery from "./CheckRecovery";
import "../css/ListPendingActivities.css";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    inline: {
      display: "inline",
    },
    paper: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 15,
      paddingRight: 15,
      marginLeft: 15,
      marginRight: 15,
    },
  });

interface ClassesInterface {
  root: string;
  inline: string;
  paper: string;
}

interface ActivityProps {
  activity: ActivityInterface;
  lesson: lessonInterface;
  classes: ClassesInterface;
}
interface QuizRelationProps {
  relation: quizInterface;
}
const Activity = ({ activity, lesson }: ActivityProps) => {
  const { type } = activity;
  // Only to satisfy typescript (see https://material-ui.com/guides/typescript/)
  const MyLink = (props: any) => (
    <RouterLink
      style={{ color: "black" }}
      to={{ pathname: "/viewActivity", state: { activity, lesson } }}
      {...props}
    />
  );

  return (
    <Fragment>
      <ListItem component={MyLink} alignItems="flex-start">
        <Typography variant="caption">
          {type} - {activity.title}
        </Typography>
      </ListItem>
    </Fragment>
  );
};
export const ColorAttention = (date: string) => {
  let currentColor = "default";
  let currentDate = new Date().getTime();
  let datePros = new Date(date).getTime();
  let week4 = 2419200000;
  let week6 = 3628800000;
  let week8 = 4838400000;
  if (currentDate - datePros >= week4 && currentDate - datePros < week6) {
    currentColor = "week4";
  }
  if (currentDate - datePros >= week6 && currentDate - datePros < week8) {
    currentColor = "week6";
  }
  if (currentDate - datePros >= week8) {
    currentColor = "week8";
  }
  return currentColor;
};

const Quiz = ({ relation }: QuizRelationProps) => {
  const MyLink = (props: any) => (
    <RouterLink
      style={{ color: "black" }}
      to={{ pathname: "/quiz/" + relation.quizByQuiz.id }}
      {...props}
    />
  );

  return (
    <Fragment>
      <ListItem component={MyLink} alignItems="flex-start">
        <Typography variant="caption">{relation.quizByQuiz.name}</Typography>
      </ListItem>
    </Fragment>
  );
};

interface ListActivitiesProps {
  classes?: ClassesInterface;
}

const ListActivities = observer(({ classes }: ListActivitiesProps) => {
  const store = useContext(StoreContext);
  const [isLoading, setIsLoading] = React.useState(false);

  const email = store.email;
  const turmaId = store.ui.turma.id;

  const { data: grades } = useQuery(GET_GRADES, {
    variables: { turma: store.ui.turma.id, email: store.email },
    fetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true,
  });

  const { data, error, loading, refetch } = useQuery<getAllACtivitiesInterface>(
    getAllActivities,
    {
      variables: { email, turmaId },
      fetchPolicy: "cache-first",
      notifyOnNetworkStatusChange: true,
    }
  );

  const handleModularEnrollment = async () => {
    setIsLoading(true);

    try {
      localStorage.setItem("lastModularTurma", store.ui.turma.name);

      await axios.post(
        "/.netlify/functions/re_enroll_modular",
        {
          email,
          course: store.ui.turma.course,
          turma: store.ui.turma.name,
        },
        { timeout: 15000 }
      );

      setIsLoading(false);
      alert(
        "Rematrícula realizada com sucesso! Acesse a nova turma no menu à esquerda."
      );
      window.location.reload();
    } catch (e) {
      console.log("Erro na rematrícula:", e);

      if (
        (e as any).code === "ECONNABORTED" ||
        ((e as any).message && (e as any).message.includes("timeout"))
      ) {
        setIsLoading(false);
        alert(
          `O servidor demorou para responder, mas a rematrícula provavelmente foi realizada com sucesso. A página será recarregada. Verifique se a nova turma aparece no menu.`
        );

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if ((e as any).response && (e as any).response.status === 500) {
        setIsLoading(false);
        alert(
          `Ocorreu um erro no servidor, mas a rematrícula pode ter sido realizada. A página será recarregada. Verifique se a nova turma aparece no menu.`
        );

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        setIsLoading(false);
        alert(
          `Erro ao realizar a rematrícula: ${
            (e as Error).message
          }. Tente novamente.`
        );
      }
    }
  };

  // see https://github.com/apollographql/apollo-client/issues/3660
  if (loading && isEmpty(data)) return <p>Carregando... </p>;
  if (error) return <p>ERROR: {error.message}</p>;
  const lesson = data!.lesson;
  const quiz_relation = data!.quiz_relation;
  store.ui.refetch = refetch;

  console.log("Grades data:", grades);
  console.log("Quiz relations:", quiz_relation);

  const quizPairs = {
    1177: 1162,
    1162: 1177,
    1163: 1178,
    1178: 1163,
  };

  const isPendingQuiz = (r: any) => {
    console.log("isPendingQuiz called for quiz:", r.quizByQuiz.name, "Admin:", store.admin);
    
    if (r.quizByQuiz.id in quizPairs) {
      const otherQuizId = quizPairs[r.quizByQuiz.id as keyof typeof quizPairs];
      const otherQuiz = quiz_relation.find(
        (q) => q.quizByQuiz.id === otherQuizId
      );
      return (
        !r.quizByQuiz.quiz_attempts[0] &&
        (!otherQuiz || !otherQuiz.quizByQuiz.quiz_attempts[0])
      );
    }
    // Se não tem tentativas
    if (!r.quizByQuiz.quiz_attempts[0]) {
      // Se é prova de recuperação, só mostra se CheckRecovery permite
      if (r.quizByQuiz.name.toUpperCase().includes("RECUPERAÇÃO")) {
        const shouldShow = CheckRecovery(quiz_relation, grades);
        console.log("Recovery quiz check result:", shouldShow);
        return shouldShow;
      }
      // Se não é prova de recuperação, sempre mostra
      return true;
    }
    // Se já tem tentativas, não mostra
    return false;
  };

  const pendingQuizzes = quiz_relation.filter((r) => {
    console.log("Filtering quiz:", r.quizByQuiz.name, "Has attempts:", r.quizByQuiz.quiz_attempts.length > 0);
    
    if (store.ui.turma.name.includes("RFT")) {
      return !r.quizByQuiz.quiz_attempts[0];
    }
    console.log(r.quizByQuiz.quiz_attempts);
    return isPendingQuiz(r);
  });
  const validTurmaIds: number[] = [361, 360, 398, 357, 443,444];
  const validModularTurmaIds: number[] = [447, 448, 449, 450, 483, 484, 481, 482, 517, 518, 525, 527, 519, 520, 528, 529];
  var re_enroll = validTurmaIds.includes(turmaId);
  const re_enroll_modular = validModularTurmaIds.includes(turmaId);

  const hiddenQuizTurmaIds = [361, 360, 398, 357, 400, 362, 399, 358,438,439, 522, 521,534,520,448,482,519,532,447,481];

  return (
    <>
      {re_enroll_modular && (
        <div style={{ marginBottom: "20px", display: "hidden" }}>
          <Paper className={classes!.paper} elevation={2}>
            <Typography variant="h5">
              Próximo módulo disponível. Clique no botão abaixo para continuar e
              acesse a próxima turma no menu à esquerda:
            </Typography>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "10px" }}
              disabled={isLoading}
              onClick={handleModularEnrollment}
            >
              {isLoading ? (
                <>
                  <CircularProgress
                    size={24}
                    color="inherit"
                    style={{ marginRight: "10px" }}
                  />
                  Processando...
                </>
              ) : (
                "IR PARA O PRÓXIMO MÓDULO."
              )}
            </Button>
          </Paper>
        </div>
      )}
      {re_enroll && (
        <div style={{ marginBottom: "20px", display: "hidden" }}>
          <Paper className={classes!.paper} elevation={2}>
            <Typography variant="h5">
              Rematrícula para o próximo período liberada.
              <br />
              Clique no botão para registrar e acesse a próxima turma no menu à
              esquerda:
            </Typography>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "10px" }}
              onClick={async () => {
                try {
                  let { data } = await axios.post(
                    "/.netlify/functions/re_enroll",
                    {
                      email,
                      course: store.ui.turma.course,
                      turma: store.ui.turma.name,
                    }
                  );
                  alert(JSON.stringify(data));
                  window.location.reload();
                } catch (e) {
                  alert((e as Error).message);
                }
              }}
            >
              Rematrícula
            </Button>
          </Paper>
        </div>
      )}
      {store.isTurmaModular ? (
        <Paper
          className={classes!.paper}
          elevation={2}
          style={{ marginBottom: "20px" }}
        >
          <div
            style={{
              maxWidth: "800px",
              margin: "0 auto",
              marginBottom: "20px",
            }}
          >
            <Typography
              variant="h6"
              style={{ color: "#801819", textAlign: "center" }}
            >
              Assista ao vídeo de introdução ao Painel do Aluno
            </Typography>
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/Kw4ajmS1gMU"
              title="Introdução ao Painel do Aluno"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </Paper>
      ) : (
        <Paper
          className={classes!.paper}
          elevation={2}
          style={{ marginBottom: "20px" }}
        >
          <div
            style={{
              maxWidth: "800px",
              margin: "0 auto",
              marginBottom: "20px",
            }}
          >
            <Typography
              variant="h6"
              style={{ color: "#801819", textAlign: "center" }}
            >
              Assista ao vídeo de introdução ao Painel do Aluno
            </Typography>
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/Oi18Lb9AnkI"
              title="Introdução ao Painel do Aluno"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </Paper>
      )}

      {store.ui.turma.course.includes("ACT") ||
      store.ui.turma.course.includes("RFT") ||
      store.ui.turma.course.includes("FAP") ? (
        <Paper
          className={classes!.paper}
          elevation={2}
          style={{ marginBottom: 20 }}
        >
          <Typography variant="h6" style={{ color: "#801819" }}>
            Cores de alerta:{" "}
          </Typography>
          <div className="captionColors">
            {" "}
            <div className="yellowColor" /> Atividade ou avaliação pendente há
            mais de 4 semanas{" "}
          </div>
          <div className="captionColors">
            {" "}
            <div className="orangeColor" /> Atividade ou avaliação pendente há
            mais de 6 semanas{" "}
          </div>
          <div className="captionColors">
            {" "}
            <div className="redColor" /> Atividade ou avaliação pendente há mais
            de 8 semanas{" "}
          </div>
        </Paper>
      ) : (
        ""
      )}
      {!store.admin && !hiddenQuizTurmaIds.includes(turmaId) && (
        <div
          style={{
            display: pendingQuizzes.length > 0 ? "block" : "none",
            marginBottom: "20px",
          }}
        >
          <Paper className={classes!.paper} elevation={2}>
            <Typography variant="h6" style={{ color: "#801819" }}>
              Avaliações Pendentes:
            </Typography>
            <List className={classes!.root}>
              <div className={store.ui.turma.org === "EMF" ? "provasEMF" : ""}>
                {pendingQuizzes.map((r) => (
                  <div
                    className={
                      store.ui.turma.course.includes("ACT") ||
                      store.ui.turma.course.includes("FAP") ||
                      store.ui.turma.course.includes("RFT")
                        ? ColorAttention(r.quizByQuiz.created_at)
                        : "default"
                    }
                  >
                    <Quiz relation={r} />
                  </div>
                ))}
              </div>
            </List>
          </Paper>
        </div>
      )}
      {store.admin && (
        <div
          style={{
            display: quiz_relation.length > 0 ? "block" : "none",
            marginBottom: "20px",
          }}
        >
          <Paper className={classes!.paper} elevation={2}>
            <Typography variant="h6" style={{ color: "#801819" }}>
              Avaliações:
            </Typography>
            <List className={classes!.root}>
              {quiz_relation
                .filter(
                  (r) =>
                    !(r.quizByQuiz.id in quizPairs) ||
                    r.quizByQuiz.id >
                      quizPairs[r.quizByQuiz.id as keyof typeof quizPairs]
                )
                .map((r) => {
                  return (
                    <div
                      className={
                        store.ui.turma.course.includes("ACT") ||
                        store.ui.turma.course.includes("FAP")
                          ? ColorAttention(r.quizByQuiz.created_at)
                          : "default"
                      }
                    >
                      <Quiz relation={r} />
                    </div>
                  );
                })}
            </List>
          </Paper>
        </div>
      )}
      <div
        style={{
          display:
            store.ui.painel.pendentes && !store.ui.turma.name.includes("J1")
              ? "block"
              : "none",
        }}
      >
        {!store.ui.turma.name.includes("Rodas") &&
        !store.ui.turma.name.includes("Supervisão") ? (
          <Paper className={classes!.paper} elevation={2}>
            <Typography variant="h6" style={{ color: "#801819" }}>
              Relatório de Atividades Pendentes
            </Typography>
            <Typography variant="subtitle1" style={{ color: "#801819" }}>
              (Atividades já realizadas estão na página Atividades)
            </Typography>{" "}
            <br />
            {lesson.map((l) => (
              <ListHolder
                store={store}
                key={l.id}
                lesson={l}
                classes={classes}
              />
            ))}
          </Paper>
        ) : (
          <Paper className={classes!.paper} elevation={2}>
            <Typography variant="h5">
              Vídeos que você ainda não assistiu
            </Typography>
            <Typography variant="h6">
              (Vídeos que você já assistiu estão na página Vídeos)
            </Typography>{" "}
            <br />
            {lesson.map((l) => (
              <ListHolder
                store={store}
                key={l.id}
                lesson={l}
                classes={classes}
              />
            ))}
          </Paper>
        )}
      </div>
    </>
  );
});

interface ListHolderProps {
  store: storeInterface;
  lesson: lessonInterface;
  classes?: ClassesInterface;
}

const ListHolder = ({ lesson, classes }: ListHolderProps) => {
  const pendingActivities = lesson.activities.filter((act) =>
    !act.deleted_at && act.activity_completions[0]
      ? !act.activity_completions[0].completed
      : act.available && act.type !== "Avaliação"
      ? true
      : false
  );
  if (pendingActivities.length > 0) {
    store.ui.painel.pendentes = true;
  }
  return (
    <Fragment>
      {pendingActivities.length > 0 && (
        <Fragment>
          <br />
          {!store.ui.turma.course.includes("Rodas") &&
          !store.ui.turma.course.includes("Supervisão") ? (
            <Typography variant="body1">
              Lição {lesson.number.toString()}: {lesson.title} (
              {pendingActivities.length.toString()} pendentes)
            </Typography>
          ) : (
            <Typography variant="body1">
              Vídeo {lesson.number.toString()}: {lesson.title} (
              {pendingActivities.length.toString()} pendentes)
            </Typography>
          )}
          <br />
          <List className={classes!.root}>
            {pendingActivities.map((activity) => {
              return (
                <div
                  className={
                    store.ui.turma.course.includes("ACT") ||
                    store.ui.turma.course.includes("FAP")
                      ? ColorAttention(lesson.start_date)
                      : "default"
                  }
                >
                  <Activity
                    key={activity.id}
                    activity={activity}
                    lesson={lesson}
                    classes={classes!}
                  />
                </div>
              );
            })}
          </List>
        </Fragment>
      )}
    </Fragment>
  );
};

export default withStyles(styles, { withTheme: true })(ListActivities);
